import React, { Component } from 'react';
import './ImageStandalone.scss';

export default class ImageStandalone extends Component {
  render() {
    const gridArea = this.props.gridArea || '';

    const {
      image = null,
      orientation = 'square',
      borderColor = '',
      instagramImage = null,
      index = 0,
      bgImage = null
    } = this.props;

    if (!image && !instagramImage) {
      return null;
    }

    const asset = (image && image.asset) || (instagramImage && instagramImage.asset) || '';

    const shift = index % 2 === 0 ? 'left' : 'right';

    // Safe style object construction
    const backgroundStyle = {};
    if (bgImage && bgImage.background && bgImage.background.dataOriginal) {
      backgroundStyle.backgroundImage = `url(${bgImage.background.dataOriginal})`;
    }
    
    if (bgImage && bgImage.focus && bgImage.focus.x != null && bgImage.focus.y != null) {
      backgroundStyle.backgroundPosition = `${bgImage.focus.x * 100}% ${bgImage.focus.y * 100}%`;
    }

    return (
      <React.Fragment>
        {bgImage && bgImage.background && Object.keys(backgroundStyle).length > 0 ? (
          <div
            className={`image-standalone ${orientation} ${gridArea} ${shift}`}
          >
            <div 
              className="image-standalone__bg"
              style={backgroundStyle}
              dangerouslySetInnerHTML={{ __html: asset }}>
            </div>
          </div>
        ) : (
          <div
            className={`image-standalone ${orientation} ${
              borderColor ? 'border' : ''
            } ${gridArea} ${shift}`}
          >
            <div
              className={`image-standalone__${orientation} ${
                borderColor
                  ? `border-color--${borderColor} border-thickness--thick`
                  : ''
              }`}
              dangerouslySetInnerHTML={{ __html: asset }}
            />
          </div>
        )}
      </React.Fragment>
    );
  }
}
